import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { ImpactLanguage } from '@upright/common/model/input/types';
import { EQUAL_WEIGHTS_TITLE } from '@upright/common/model/input/value-sets';
import { ScoreReader } from '@upright/common/model/output/scores/score-reader';
import { FinalImpactScoreType, NetScoreFormat } from '@upright/common/model/output/scores/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import {
  defaultNetImpactLensScoreUnit,
  NetImpactLensSelectionState,
} from '@upright/ui/common/upright/core/impact-lenses/net-impact/selection-state';
import {
  NetImpactLensData,
  NetImpactLensOptions,
} from '@upright/ui/common/upright/core/impact-lenses/net-impact/types';
import { getImpactScoreFormattersFromScoreReaders } from '@upright/ui/common/upright/model/output/scores/net-impact-chart/value-formatter';

export function defaultNetImpactLensOptions(
  data: NetImpactLensData,
  sel: NetImpactLensSelectionState,
  passedOptions: Partial<NetImpactLensOptions> | undefined,
): NetImpactLensOptions {
  const [scoreUnit, relativeMode] = getScoreUnit(passedOptions?.scoreUnit);

  const scoreReader = new ScoreReader(
    { [FinalImpactScoreType.RELATIVE]: data.scores },
    scoreUnit,
    data.revenue,
    undefined, // Value set does not affect the impact chart, only the net value below it.
  );
  const formatters = getImpactScoreFormattersFromScoreReaders([scoreReader], {
    hideCurrencyUnits: sel.hideCurrencyUnits === true,
  });
  return {
    // context related to net impact lens (move to separate part)
    type: ImpactLensType.UPRIGHT_NET_IMPACT,
    netScoreFormat: NetScoreFormat.NET_RATIO,
    scoreReader,
    scoreUnit,
    relativeMode,
    onContributeClick: () => undefined,
    formatters,
    staticMode: false,
    version: 'master',
    language: ImpactLanguage.en,
    negativeColor: BouColor.IMPACT_NEGATIVE_PURPLE,
    positiveColor: BouColor.IMPACT_POSITIVE_GREEN,
    showDimensionBars: false,
    valueSet: EQUAL_WEIGHTS_TITLE,
    disableLinks: false,
    disableResponsiveBoxMode: false,
    disableValueSetSelector: false,
    hideNetScore: false,
    hideRenderViewButton: false,
    hideSuggestFixes: false,
    versionTextOptions: {
      showTimezone: false,
      hideVariantLink: false,
    },
  };
}

function getScoreUnit(scoreUnit: FinalImpactScoreType | undefined) {
  switch (scoreUnit) {
    case FinalImpactScoreType.CENTS_PER_DOLLAR:
      return [scoreUnit, true] as const;
    case FinalImpactScoreType.DOLLARS_PER_YEAR:
      return [scoreUnit, false] as const;
    case FinalImpactScoreType.RELATIVE:
      return [scoreUnit, true] as const;
    default:
      return [defaultNetImpactLensScoreUnit, true] as const;
  }
}
